import type { ReactNode } from "react";
import { QueryCache, QueryClient, QueryClientProvider, MutationCache } from "@tanstack/react-query";
import { reportClientError } from "../utils/reportClientError";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => reportClientError(error, "QUERY_ERROR"),
  }),
  mutationCache: new MutationCache({
    onError: (error) => reportClientError(error, "MUTATION_ERROR"),
  }),
});

export const QueryProvider = ({ children }: { children: ReactNode }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);
